export default __webpack_public_path__ + "static/media/AIBtn.90ee58b8.gif";